import { render } from "./V4StyleBottom.vue?vue&type=template&id=358620a0&scoped=true"
import script from "./V4StyleBottom.vue?vue&type=script&lang=js"
export * from "./V4StyleBottom.vue?vue&type=script&lang=js"

import "./V4StyleBottom.vue?vue&type=style&index=0&id=358620a0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358620a0"]])

export default __exports__